import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
import type { PropsWithChildren, Ref } from 'react';
import { isSxArray } from 'src/shared/utils/isSxArray';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../../ColumnContext';
type CardAndTitleContainerProps = {
  innerRef: Ref<HTMLDivElement>;
  additionalProps?: BoxProps;
};
export function CardAndTitleContainer(t0) {
  const $ = _c(17);
  const {
    innerRef,
    additionalProps,
    children
  } = t0;
  const {
    index
  } = useCreditCardCompareColumnContext();
  let t1;
  if ($[0] !== additionalProps) {
    t1 = additionalProps ?? {};
    $[0] = additionalProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    sx
  } = t1;
  let t2;
  if ($[2] !== sx) {
    t2 = sx && isSxArray(sx) ? sx : sx ? [sx] : [];
    $[2] = sx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const extendedSx = t2;
  const t3 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t4;
  if ($[4] !== t3) {
    t4 = {
      md: "flex",
      xs: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      xs: 0,
      md: 2
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = {
      display: t4,
      flexDirection: "column",
      alignItems: "center",
      flex: 1,
      pb: t5
    };
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== extendedSx || $[10] !== t6) {
    t7 = [t6, ...extendedSx];
    $[9] = extendedSx;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== additionalProps || $[13] !== children || $[14] !== innerRef || $[15] !== t7) {
    t8 = <Box ref={innerRef} {...additionalProps} sx={t7}>{children}</Box>;
    $[12] = additionalProps;
    $[13] = children;
    $[14] = innerRef;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}